module.exports = __webpack_public_path__ + "img/blueCircle.77a17290.png";